import script from "./IndexTamu.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexTamu.vue?vue&type=script&setup=true&lang=js"

import "./IndexTamu.vue?vue&type=style&index=0&id=85ea12e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85ea12e6"]])

export default __exports__